import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { SHARED_IMPORTS } from '../../shared/modules/shared-imports.module';
import { QuickMenu } from '@core/layout/menu/quick-menu/quick-menu';
import { QuickMenuItem } from '@core/layout/menu/quick-menu/menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';

@Component({
  selector: 'app-home',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './home.html',
  styleUrl: './home.css',
  imports: [/*RouterLink,*/ ...SharedMaterialUIModule, ...SHARED_IMPORTS, QuickMenu]
})
export class Home {
  private keycloak = inject(Keycloak);
  protected readonly verifyPermissions = CHECK_PERMISSIONS();

  protected async login(): Promise<void> {
    await this.keycloak.login();
  }

  protected readonly menuItems: QuickMenuItem[] = [
    {title: 'Users', icon: 'manage_accounts', route: '/user-management/users', validPermission: this.verifyPermissions.canManageUsers()},
    {title: 'Employees', icon: 'groups', route: '/employees', validPermission: this.verifyPermissions.canReadEmployees()},
    {title: 'Affiliates', icon: 'medical_services', route: '/affiliates', validPermission: this.verifyPermissions.canReadAffiliates()},
    {title: 'Interventions', icon: 'health_and_safety', route: '/interventions', validPermission: this.verifyPermissions.canReadInterventions()},
    {title: 'Clients', icon: 'business', route: '/clients', validPermission: this.verifyPermissions.canReadClients()},
  ];
}
